import React, { useState } from "react";
import Header from "../../common/component/header/Header";
import Sidebar from "../../common/component/sidebar/Sidebar";
import OrderSpecific from "./component/orderCreation/OrderSpecific";
import DoneIcon from "@mui/icons-material/Done";
import "./index.css";
import OrderLine from "./component/orderCreation/OrderLine";
import OrderPlan from "./component/orderCreation/OrderPlan";
import MainLayout from "../../common/layout/MainLayout";
import DocUpload from "./component/orderCreation/DocUpload";

function Order() {
  const [previousDisabled, setPreviousDisabled] = useState(true);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  return (
    <MainLayout>
      <div className="_orderCreation">
        <div className="_order-creation-timeline-Parent">
          <div className="_order-creation-timeline">
            <hr />
            <div className="_order-creation-timeline-div">
              <div className="_order-creation-timeline-name first active">
                <div className="_order-creation-timeline-dot">
                  <div></div>
                </div>
                <p>Order Specifics</p>
              </div>
              <div className="_order-creation-timeline-name done">
                <div className="_order-creation-timeline-dot">
                  <div>
                    <DoneIcon />
                  </div>
                </div>
                <p>Line Details</p>
              </div>
              <div className="_order-creation-timeline-name">
                <div className="_order-creation-timeline-dot">
                  <div></div>
                </div>
                <p>Order Plan</p>
              </div>
              <div className="_order-creation-timeline-name">
                <div className="_order-creation-timeline-dot">
                  <div></div>
                </div>
                <p>E-Doc Upload</p>
              </div>
              <div className="_order-creation-timeline-name last">
                <div className="_order-creation-timeline-dot">
                  <div></div>
                </div>
                <p>Confirmation</p>
              </div>
            </div>
          </div>
        </div>
        {/* <OrderSpecific /> */}
        {/* <OrderLine /> */}
        {/* <OrderPlan /> */}
        <DocUpload />
      </div>
      <div className="_order-creation-footer">
        <div className="_order-creation-footer-left">
          <div className="_outlineButton">
            <button className="">SAVE AND CONTINUE LATER</button>
          </div>
          <div className="_solidButton">
            <button disabled={previousDisabled}>PREVIOUS</button>
          </div>
        </div>
        <div className="_order-creation-footer-right">
          <div className="_solidButton">
            <button disabled={nextDisabled}>NEXT</button>
          </div>
        </div>
      </div>
    </MainLayout>
    //   </div>
    // </div>
  );
}

export default Order;
